import { cn } from "@/lib/utils";
import React, { HTMLAttributes, useRef, useImperativeHandle } from "react";
import TextArea, { TextAreaProps } from "./Textarea";

export type StyledTextAreaProps = {
  label?: string;
  iconSrc?: string;
  containerClassName?: HTMLAttributes<HTMLDivElement>["className"];
  labelClassName?: HTMLAttributes<HTMLSpanElement>["className"];
  suggestionsComponent?: React.ReactNode;
} & TextAreaProps;

const StyledTextArea = React.forwardRef<
  HTMLTextAreaElement,
  StyledTextAreaProps
>(
  (
    {
      label,
      containerClassName,
      iconSrc,
      suggestionsComponent,
      labelClassName,
      className,
      ...otherProps
    },
    ref
  ) => {
    const innerRef = useRef<HTMLTextAreaElement>(null);
    useImperativeHandle(ref, () => innerRef.current as HTMLTextAreaElement);

    return (
      <div
        className={cn(
          "flex flex-col items-start justify-center gap-2 rounded-lg bg-muted px-6 py-8 text-primary",
          containerClassName
        )}
      >
        {label && (
          <span className={cn("text-xs text-muted-foreground", labelClassName)}>
            {label}
          </span>
        )}
        <div className="flex w-full flex-row items-center justify-center">
          <img src={iconSrc} alt={label} />
          <div className="relative w-full">
            <TextArea
              ref={innerRef}
              {...otherProps}
              className={cn(
                "border-0 bg-transparent text-3xl focus-visible:ring-0 focus-visible:ring-offset-0",
                className
              )}
            />
            {suggestionsComponent}
          </div>
        </div>
      </div>
    );
  }
);

StyledTextArea.displayName = "StyledTextArea";

export default StyledTextArea;
